// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '3bfd5fce-81e5-48fc-a177-94b174156c66',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3bfd5fce-81e5-48fc-a177-94b174156c66'
    },
    {
      id: '16bfe576-b609-4efe-b2da-77032946de02',
      type: 'Text',
      name: 'levelText',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 50,
      maxHeight: 60,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#6F1F0C',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.45,
        dropShadowBlur: 0,
        dropShadowColor: '#6F1F0C',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3bfd5fce-81e5-48fc-a177-94b174156c66'
    },
    {
      id: '89f5eb2a-099e-4fd6-bc94-49cc71480692',
      type: 'Container',
      name: 'notification',
      className: '',
      x: 64,
      y: -50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3bfd5fce-81e5-48fc-a177-94b174156c66'
    },
    {
      id: '5f480cf8-d4be-41a1-abc6-f2c0267d7e47',
      type: 'Sprite',
      name: 'rays',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.275,
        y: 0.275
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '5325c12d-148f-4678-b852-87690f1775e3',
      type: 'Container',
      name: 'sparkleParticlesSlot',
      className: '',
      x: 1,
      y: 44,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '570c7760-744f-4e20-b7e5-fdc536bf9c99',
      type: 'Container',
      name: 'progressBarSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '3b3e231f-032c-4713-a40e-518a8efc2f10',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Shadow_Overlay',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '3c9dc085-b6b0-47d0-b4fe-b5020d5d6a57',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Top',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '865333a5-a538-45c4-a246-d75559667011',
      type: 'Sprite',
      name: 'flag',
      className: '',
      x: 0,
      y: -42,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Icon_Race_Flag',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '838dc8a9-7e42-4efa-a9d9-7b25e0ae4cd0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Icon_Node',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '48fa306c-0957-470a-bd45-0a899977c0c5',
      type: 'Sprite',
      name: 'timerContainer',
      className: '',
      x: 0,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Counter',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0',
      stateByName: {
        full: {
          texture: 'Main_Menu_Icon_Counter_Full'
        }
      }
    },
    {
      id: '078e2b78-baf4-4ece-a7ce-8e34b1fffee9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Notification_Dot',
      parent: '89f5eb2a-099e-4fd6-bc94-49cc71480692'
    },
    {
      id: '72dbfaf3-e499-445a-a149-43591a2502cb',
      type: 'Text',
      name: 'notificationText',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '!',
      localize: false,
      maxWidth: 30,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '89f5eb2a-099e-4fd6-bc94-49cc71480692'
    },
    {
      id: '205a2d2a-93a1-4c00-aa3d-82752d9ec70f',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.55
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d 12h',
      localize: false,
      maxWidth: 85,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6F1F0C',
        stroke: '#ffffff',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: '#007fff',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '48fa306c-0957-470a-bd45-0a899977c0c5',
      stateByName: {
        full: {
          text: 'Full',
          localize: true,
          style: {
            stroke: '#A73151',
            fill: '#ffffff',
            strokeThickness: 5
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    'loseLevelIcon'
  ],
  handleResize: false
} as const;

export class WinStreakMenuIconLayout {
  static raw = raw;
  root!: Container;
  levelText!: Text;
  notification!: Container;
  rays!: Sprite;
  sparkleParticlesSlot!: Container;
  progressBarSlot!: Container;
  flag!: Sprite;
  timerContainer!: Sprite;
  notificationText!: Text;
  timerText!: Text;
  StateName!: 'loseLevelIcon';

  constructor() {
    populate(this, raw);
  }
}
